import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from './auth/guards/admin.guard';
import { UserGuard } from './auth/guards/user.guard';
import { LoginComponent } from './auth/login/login.component';
import { NavigationLayoutComponent } from './layouts/navigation-layout/navigation-layout.component';
import { NavigationlessLayoutComponent } from './layouts/navigationless-layout/navigationless-layout.component';
import { OverviewComponent } from './views/admin/overview/overview.component';
import { UserCreateComponent } from './views/admin/user-create/user-create.component';
import { UserDetailComponent } from './views/admin/user-detail/user-detail.component';
import { UserListComponent } from './views/admin/user-list/user-list.component';
import { AllianceDetailComponent } from './views/alliance-detail/alliance-detail.component';
import { AllianceListComponent } from './views/alliance-list/alliance-list.component';
import { HomeComponent } from './views/home/home.component';
import { PlayerDetailComponent } from './views/player-detail/player-detail.component';
import { PlayerListComponent } from './views/player-list/player-list.component';
import { ScanDetailComponent } from './views/scan-detail/scan-detail.component';
import { ScanListComponent } from './views/scan-list/scan-list.component';
import { StellarCartographyComponent } from './views/stellar-cartography/stellar-cartography.component';
import { ChangelogComponent } from './views/changelog/changelog.component';
import { UnauthorizedComponent } from './views/unauthorized/unauthorized.component';

const routes: Routes = [

  {
    path: 'admin',
    component: NavigationLayoutComponent,
    canActivate: [AdminGuard],
    runGuardsAndResolvers: 'always',
    children: [
      { path: 'overview', component: OverviewComponent },
      { path: 'user/list', component: UserListComponent },
      { path: 'user/create', component: UserCreateComponent },
      { path: 'user/:id', component: UserDetailComponent },
    ],
  },
  {
    path: '',
    component: NavigationLayoutComponent,
    canActivate: [UserGuard],
    runGuardsAndResolvers: 'always',
    children: [
      { path: '', component: HomeComponent },
      { path: 'player/list', component: PlayerListComponent },
      { path: 'player/:id', component: PlayerDetailComponent },
      { path: 'alliance/list', component: AllianceListComponent },
      { path: 'alliance/:id', component: AllianceDetailComponent },
      { path: 'scan/list', component: ScanListComponent },
      { path: 'scan/:id', component: ScanDetailComponent },
      { path: 'changelog', component: ChangelogComponent },
      { path: 'stellar-cartography', component: StellarCartographyComponent },
      {
        path: 'stellar-cartography/:y/:x',
        component: StellarCartographyComponent,
      },
    ],
  },

  {
    path: '',
    component: NavigationlessLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'unauthorized', component: UnauthorizedComponent },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
